import { cellRenderParseData } from '../../../utils/functions';

const columnDataGrid = [
  {
    dataField: 'readyProfileSize',
    caption: 'Профилеразмер',
    dataType: 'string'
  },
  {
    dataField: 'readyAccountingDate',
    caption: 'Дата СК (ГП)',
    dataType: 'date',
    cellRender: cellRenderParseData
  },
  {
    dataField: 'readyBatchId',
    caption: 'Партия SAP (ГП)',
    dataType: 'string'
  },
  {
    dataField: 'readyQcId',
    caption: '№ партии ГП (СК)',
    dataType: 'string'
  },
  {
    dataField: 'readyPieceId',
    caption: 'Номер УЕ (ГП)',
    dataType: 'string'
  },
  {
    dataField: 'readyPsStatusName',
    caption: 'Статус УЕ (ГП)',
    dataType: 'string'
  },
  {
    dataField: 'readyWeightNetto',
    caption: 'Кол-во ГП, теор.',
    dataType: 'number'
  },
  {
    dataField: 'readyWeightOff',
    caption: 'Кол-во ГП, факт.',
    dataType: 'number'
  },
  {
    dataField: 'readyZdvlOrderId',
    caption: 'Заказ ZDVL',
    dataType: 'number'
  },
  {
    dataField: 'readyZdvlLineId',
    caption: 'Позиция ZDVL',
    dataType: 'string'
  },
  {
    dataField: 'readyLength',
    caption: 'Длина',
    dataType: 'string'
  },
  {
    dataField: 'thick',
    caption: 'Толщина',
    dataType: 'string'
  },
  {
    dataField: 'width',
    caption: 'Ширина',
    dataType: 'string'
  },
  {
    dataField: 'readyMark',
    caption: 'Марка стали',
    dataType: 'string'
  },
  {
    dataField: 'readyNormativeDoc',
    caption: 'Номативный документ',
    dataType: 'string'
  },
  {
    dataField: 'readyQty',
    caption: 'Количество ГП',
    dataType: 'number'
  },
  {
    dataField: 'qcId',
    caption: 'CK(ПФ)',
    dataType: 'number'
  },
  {
    dataField: 'accountingDate',
    caption: 'Дата СК (ПФ)',
    dataType: 'date',
    cellRender: cellRenderParseData
  },
  {
    dataField: 'productGroupDescription',
    caption: 'Продукт (ПФ)',
    dataType: 'string'
  },
  {
    dataField: 'batchId',
    caption: 'Партия SAP (ПФ)',
    dataType: 'string'
  },
  {
    dataField: 'cgId',
    caption: 'Номер партии',
    dataType: 'string'
  },
  {
    dataField: 'actualPieceId',
    caption: 'Номер УЕ (ПФ)',
    dataType: 'string'
  },
  {
    dataField: 'psStatusName',
    caption: 'Статус УЕ (ПФ)',
    dataType: 'string'
  },
  {
    dataField: 'quantity',
    caption: 'Кол-во',
    dataType: 'number'
  },
  {
    dataField: 'quantityRemain',
    caption: 'Кол-во ост.',
    dataType: 'number'
  },
  {
    dataField: 'unitShort',
    caption: 'ЕИ',
    dataType: 'string'
  },
  {
    dataField: 'weightEndProduct',
    caption: 'Вес списания ПФ, т.',
    dataType: 'number'
  },
  {
    dataField: 'percentWasteMaterial',
    caption: '% отходов',
    dataType: 'number'
  },
  {
    dataField: 'readyMessageId',
    caption: '№ сообщения в SAP',
    dataType: 'string'
  },
  {
    dataField: 'weightSumOff',
    caption: 'Кол-во списания ПФ, SAP',
    dataType: 'number'
  },
  {
    dataField: 'taskNumber',
    caption: 'Номер задания',
    dataType: 'string'
  },
  {
    dataField: 'pieceId',
    caption: 'Маркировка',
    dataType: 'string'
  },
  {
    dataField: 'plantDescr',
    caption: 'Склад',
    dataType: 'string'
  }
];

export default columnDataGrid;
